import { render, staticRenderFns } from "./RiderTodayDelivery.vue?vue&type=template&id=3881fed0&scoped=true"
import script from "./RiderTodayDelivery.vue?vue&type=script&lang=js"
export * from "./RiderTodayDelivery.vue?vue&type=script&lang=js"
import style0 from "./RiderTodayDelivery.vue?vue&type=style&index=0&id=3881fed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881fed0",
  null
  
)

export default component.exports